export const invitationText = (value) => {
  if (typeof value !== "string") return "";
  const text = value.trim();
  return /^(null|undefined)$/i.test(text) ? "" : text;
};

export const formatInvitationDate = (value) => {
  const text = invitationText(value);
  if (!text) return "";
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
  // Calendar dates have no timezone or time; timestamps retain browser-local behavior.
  const date = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(text);
  if (Number.isNaN(date.getTime())) return "";
  if (dateOnly && (date.getFullYear() !== Number(dateOnly[1]) ||
    date.getMonth() !== Number(dateOnly[2]) - 1 || date.getDate() !== Number(dateOnly[3]))) return "";
  const day = date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  if (dateOnly) return day;
  return `${day} · ${date.toLocaleString([], { hour: "2-digit", minute: "2-digit" })}`;
};

export const formatInvitationAddress = ({ venue, area, city, state } = {}) => {
  const parts = [];
  const normalize = (text) => text.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
  [venue, area, city, state].forEach((value) => {
    const part = invitationText(value);
    const normalized = normalize(part);
    if (normalized && !parts.some((existing) =>
      ` ${normalize(existing)} `.includes(` ${normalized} `))) parts.push(part);
  });
  return parts.join(" · ");
};
